import { httpClient } from "./httpClient";

type Rating = {
  comments: string;
  referenceNumbers: string[];
  stars: number | null;
};

type Data = {
  success: boolean;
};

export async function putRating(rating: Rating): Promise<Data> {
  try {
    const { data } = await httpClient.put<Data>(`/api/v1/request/rating`, {
      ...rating,
    });

    return data;
  } catch (error) {
    throw error;
  }
}
